<mat-card appearance="outlined">
  <mat-card-content>
    <h2>{{ 'footer.links.confidentialityAgreement' | translate }}</h2>
    @if (translate.currentLang == 'fr') {
      <div>
        <p>
          Vos données personnelles sont très importantes. Ainsi, l’Ordre des dentistes du Québec (ci-après « l’ODQ »)
          prend toutes les mesures raisonnables afin que vos visites sur ses sites soient fiables et sécuritaires et que
          la confidentialité des renseignements que vous y déposerez, le cas échéant, soit préservée.
          <br><br>
          L’ODQ s’engage à préserver le caractère confidentiel de tous les renseignements transmis par les utilisateurs,
          conformément aux lois applicables en matière de protection des renseignements personnels.
          <br><br>
          À cet égard, l’ODQ s’assure que ces renseignements demeurent privés et ne sont pas communiqués ou divulgués à
          des tiers, sauf en cas d’autorisation expresse de votre part.
          <br><br>
          Par ailleurs, le transfert de vos renseignements personnels, au moment du transit sur Internet, est protégé par
          le protocole SSL (Secure Sockets Layer), qui crypte les données saisies, assurant notamment la confidentialité
          de vos transactions bancaires.
          <br><br>
          Lors des transactions électroniques effectuées dans la section sécurisée des sites de l’ODQ, aucune information
          en lien avec les paiements n’est enregistrée ou sauvegardée.
        </p>
      </div>
    }
    @if (translate.currentLang == 'en') {
      <div>
        Your personal data is very important. The Ordre des dentistes du Québec (hereinafter "the ODQ") takes all
        reasonable measures to ensure that your visits to its sites are reliable and secure and that the confidentiality
        of the information you provide, as required, is preserved.
        <br><br>
        The ODQ is committed to preserving the confidential nature of all information transmitted by users, in accordance
        with applicable privacy laws.
        <br><br>
        In this regard, the ODQ ensures that this information remains private and is not communicated or disclosed to
        third parties, unless specifically authorized by you.
        <br><br>
        Furthermore, the transfer of your personal information, while in transit over the Internet, is protected by the
        SSL (Secure Sockets Layer) protocol, which encrypts the data entered, ensuring, among other things, the
        confidentiality of your banking transactions.
        <br><br>
        During electronic transactions carried out in the secure section of the ODQ sites, no information related to
        payments is recorded or saved.
      </div>
    }
  </mat-card-content>
</mat-card>